import React from 'react'
import { ChatRoom } from '../../../clients/kyousou_api_client'
import { formatChatDateTime } from '../../../utils/datetime_util'
import { UnreadNotification } from '../../../types/chat'

interface ChatListProps {
  chatRooms: ChatRoom[]
  selectedChat: ChatRoom | null
  onSelectChat: (chat: ChatRoom) => void
  searchQuery: string
  onSearchChange: (query: string) => void
  unreadNotifications: Map<number, UnreadNotification>
}

const ChatRoomListSection: React.FC<ChatListProps> = ({
  chatRooms,
  selectedChat,
  onSelectChat,
  searchQuery,
  onSearchChange,
  unreadNotifications,
}) => {
  return (
    <div className="h-full flex flex-col rounded-lg overflow-hidden">
      {/* ヘッダー */}
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-lg font-bold mb-3">メッセージ</h2>
        <div className="relative">
          <input
            type="text"
            placeholder="企業名で検索"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-3 py-2 pl-10 border border-main-gray rounded-lg focus:outline-none focus:ring-2 focus:ring-main-green"
          />
          <span className="material-icons absolute left-3 top-2 text-main-darkgray text-2xl">
            search
          </span>
        </div>
      </div>

      {/* チャット一覧 */}
      <div className="flex-1 overflow-y-auto">
        {chatRooms.map((chatRoom) => (
          <div
            key={chatRoom.id}
            onClick={() => onSelectChat(chatRoom)}
            className={`flex items-center px-4 py-3 hover:bg-main-lightgray cursor-pointer border-b border-main-gray ${
              selectedChat?.id === chatRoom.id ? 'bg-main-lightgray' : ''
            }`}
          >
            {/* 企業ロゴ */}
            <div className="relative mr-3">
              <img
                src={chatRoom.logo}
                alt={chatRoom.name}
                className="w-10 h-10 rounded-full object-cover"
              />
            </div>
            {/* チャット情報 */}
            <div className="flex-1 min-w-0">
              <div className="flex justify-between items-start mb-1">
                <h3 className="font-medium text-sm truncate">
                  {chatRoom.name}
                </h3>
                <span className="text-xs text-main-darkgray ml-2 flex-shrink-0">
                  {chatRoom.lastMessage.sentAt &&
                    formatChatDateTime(new Date(chatRoom.lastMessage.sentAt))}
                </span>
              </div>
              <div className="flex items-center">
                <p className="text-sm text-main-darkgray truncate flex-1">
                  {chatRoom.lastMessage.content}
                </p>
                {/* {chat.hasMatchingRequest ? (
                  <span className="ml-2 bg-main-red text-main-white text-xs rounded px-2 py-0.5">
                    新規
                  </span>
                ) : (
                  chatRoom.unreadCount && (
                    <span className="ml-2 bg-main-green text-main-white text-xs rounded-full px-2 py-0.5 min-w-[20px] text-center">
                      {chat.unreadCount}
                    </span>
                  )
                )} */}
                {unreadNotifications.has(chatRoom.id) && (
                  <span className="ml-2 w-2 h-2 bg-main-red rounded-full flex-shrink-0"></span>
                )}
              </div>
            </div>
            {/* 矢印アイコン */}
            <span className="material-icons text-main-darkgray text-lg ml-2">
              chevron_right
            </span>
          </div>
        ))}
        {chatRooms.length === 0 && (
          <div className="flex items-center justify-center h-full">
            <p className="text-main-darkgray">チャット可能な企業がいません。</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ChatRoomListSection
